// eslint-disable-next-line frontbucket-patterns/no-new-emotion-styled
import styled from '@emotion/styled';
import { useRouter } from 'react-resource-router';

import {
  Main,
  // MainStickyHeader,
} from '@atlaskit/navigation-system/layout/main';
import { media } from '@atlaskit/primitives';

import { useNavHeight } from 'src/app/nav-system/hooks';
import { SidebarPlaceholderNavV4 } from 'src/app/sidebar';
import { UniversalRoutes } from 'src/app/universal-routes';
import { MainErrorBoundary } from 'src/components/error-boundary';
import { UpdatePref } from 'src/hooks/use-pref';
import { Site } from 'src/redux/jira/types';
import { ROUTE_NAME } from 'src/router/routes/types';
import { RovoChatFloatingButton } from 'src/sections/global/components/chat-sidebar';

import { useRovoChatContext } from '../nav-system';

// these are some of the styles we need copied from page.styled.ts. At some point we could refactor
// styles but for now going to use what's there with the v3 nav. When refactoring make sure to
// check different sidebars since they have different functionality (sticky tabs, diff content, etc.)
// mainStyle ~ pageWithSidebarStyles (in page.styled.ts)
const MainContentWrapper = styled.div<{
  topOffset: number;
}>(({ topOffset }) => ({
  display: 'flex',
  width: '100%',
  boxSizing: 'border-box',
  [media.only.sm]: {
    height: `calc(100vh - ${topOffset}px)`,
    overflowY: 'auto',
  },
  [media.below.sm]: {
    flexDirection: 'column',
  },
}));

// primaryContentStyle ~ Content (in page.styled.ts)
const PrimaryContent = styled.div({
  flex: '1 1 0px',
  minWidth: 0,
  minHeight: '100%',
  [media.below.sm]: {
    flex: 'none',
  },
});

export type NavSystemMainProps = {
  rovoEnabledSites: Site[];
  updateRovoPreferredSite: UpdatePref;
};

export const NavSystemMain = (props: NavSystemMainProps) => {
  const navHeight = useNavHeight();
  const { sidebarApi } = useRovoChatContext();

  const [{ route }] = useRouter();

  const isOnPipelinesResultPage =
    route.name === ROUTE_NAME.REPOSITORY_PIPELINES_RESULT;

  return (
    <Main>
      <MainErrorBoundary>
        {/* much of this is ~ equivilent to what's in the legacy page component used by nav v3 (src/app/page.tsx) */}
        <MainContentWrapper topOffset={navHeight}>
          <PrimaryContent>
            <UniversalRoutes />
          </PrimaryContent>
          <SidebarPlaceholderNavV4 />
        </MainContentWrapper>
        {sidebarApi && !isOnPipelinesResultPage && (
          <RovoChatFloatingButton
            rovoEnabledSites={props.rovoEnabledSites}
            updateSitePref={props.updateRovoPreferredSite}
          />
        )}
      </MainErrorBoundary>
    </Main>
  );
};
